import '../../styles-new/pages/about.scss';